module.exports = __webpack_public_path__ + "static/media/logo.a226ef83.PNG";